import { Icon, IconProps } from './Icon';

interface RecentlyCreatedIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const RecentlyCreatedIcon = ({ color = '#5E6A81', gradient, ...props }: RecentlyCreatedIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 28 28"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1667 24.5H9.33333C6.11167 24.5 3.5 21.8883 3.5 18.6667V9.33333C3.5 6.11167 6.11167 3.5 9.33333 3.5H18.6667C21.8883 3.5 24.5 6.11167 24.5 9.33333V15.1667C24.5 20.3213 20.3213 24.5 15.1667 24.5Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M24.4997 12.833V15.1663C24.4997 16.455 23.455 17.4997 22.1663 17.4997H19.833C17.9 17.4997 16.333 19.0667 16.333 20.9997V22.1663C16.333 23.455 15.2883 24.4997 13.9997 24.4997H9.33301"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M18.6663 9.33333H9.33301"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
